import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
require("firebase/functions");

const config = {
    apiKey: "AIzaSyCzntZPe2TVzra6eagmQ3xV9LAh0OvoYcY",
    authDomain: "synthackstodo.firebaseapp.com",
    databaseURL: "https://synthackstodo.firebaseio.com",
    projectId: "synthackstodo",
    storageBucket: "synthackstodo.appspot.com",
    messagingSenderId: "534474386555",
    appId: "1:534474386555:web:6b6d42988624555d5186de",
    measurementId: "G-WLQBTX49Z5"
};

class Firebase {
    constructor() {
      app.initializeApp(config);
  
      this.auth = app.auth();
      this.db = app.database();
      this.functions = app.functions()
      this.user = {}
    }
  
    // *** Auth API ***
  
    doCreateUserWithEmailAndPassword = (email, password) =>
      this.auth.createUserWithEmailAndPassword(email, password);
  
    doSignInWithEmailAndPassword = (email, password) =>
      this.auth.signInWithEmailAndPassword(email, password);
  
    doSignOut = () => this.auth.signOut();
  
    doPasswordReset = email => this.auth.sendPasswordResetEmail(email);
  
    doPasswordUpdate = password =>
      this.auth.currentUser.updatePassword(password);
    
    
    
    // *** User API ***
  
    //user = uid => this.db.ref(`users/${uid}`);
  
    locUser = () => {return this.user};

    addUser = (data) => {
      console.log("adding user")
      const addUser = this.functions.httpsCallable('addUser')
      addUser(data).then((result) => {
        this.getUser()
        return result
      })
    } 

    getUser = () => {
      const getUser = this.functions.httpsCallable('getUser')
      console.log("uid: "+JSON.stringify(this.auth.currentUser.uid))
      return new Promise((resolve) => {
        getUser(this.auth.currentUser.uid).then((result) => {
          console.log("got user: "+JSON.stringify(result))
          this.user = result.data
          resolve(this.user)
        }).catch((err) => {
          console.log("getUser: "+err)
        })
      })
      
    }

    getAll = () => {
      return new Promise((resolve) => {
        const getAll = this.functions.httpsCallable('getAll')
        getAll().then((result) => {
          console.log("got user: "+JSON.stringify(result))
          
          resolve(result)
        })
      })
      
    }

    addTask = (data) => {
      console.log("adding task")
      const addTask = this.functions.httpsCallable('addTask')
      return new Promise((resolve) => {
        addTask(data).then((result) => {
          resolve(result.data)
        })
      })
    } 

    addClass = (data) => {
      console.log("adding class")
      return new Promise((resolve) => {
        const addClass = this.functions.httpsCallable('addClass')
        addClass(data).then((result) => {
          resolve(result.data)
        })
      })
    } 

    deleteClass = (data) => {
      console.log("deleting user")
      const deleteClass = this.functions.httpsCallable('deleteClass')
      return new Promise((resolve) => {
        deleteClass(data).then((result) => {
          resolve(result.data)
        })
      })
    } 

    deleteTask = (data) => {
      console.log("deleting user")
      const deleteTask = this.functions.httpsCallable('deleteTask')
      return new Promise((resolve) => {
        deleteTask(data).then((result) => {
          resolve(result.data)
        })
      })
    } 

    updateUser = (data) => {
      console.log("updating user")
      const updateUser = this.functions.httpsCallable('updateUser')
      return new Promise((resolve) => {
        updateUser(data).then((result) => {
          resolve(result.data)
        })
      })
    } 

    updateTask = (data) => {
      console.log("updating user")
      const updateTask= this.functions.httpsCallable('updateTask')
      return new Promise((resolve) => {
        updateTask(data).then((result) => {
          resolve(result.data)
        })
      })
    } 

    updateClass = (data) => {
      console.log("updating user")
      const updateClass = this.functions.httpsCallable('updateClass')
      return new Promise((resolve) => {
        updateClass(data).then((result) => {
          resolve(result.data)
        })
      })
    } 
      
  }
  
  export default Firebase;